import { Form, Formik } from 'formik';
import * as yup from 'yup';
import * as K from 'common/constants';
import { gqlRequest } from 'common/util/gqlRequest';
import Input from 'components/common/Input/Input';
import Button, { ButtonVariant } from 'components/common/Button/Button';
import { LOGIN_WITH_PASSWORD } from './queries';
import AuthPageFooter, { getRememberMeValue } from './AuthPageFooter';
import { AUTH_PAGE_LOGIN_TYPE } from './constants';
type AuthPageFormValues = {
  email: string;
  password: string;
};

type PasswordLoginProps = {
  changeAuthMethod: () => void;
  formRef: any;
  getRedirectUrl: () => string;
  setError: (error: any) => void;
  setStatus: (status: any) => void;
  status: any;
  requestPasswordReset: () => void;
  emailToDisplay: string | undefined;
};

const loginValidationSchema = yup.object({
  email: yup.string().email().required('Please enter a valid email address'),
});

function PasswordLogin({
  changeAuthMethod,
  getRedirectUrl,
  formRef,
  setError,
  setStatus,
  status,
  emailToDisplay,
  requestPasswordReset,
}: PasswordLoginProps): JSX.Element {
  const redirectUrl: string = getRedirectUrl();

  async function authenticateLoginPassword({ email, password }: AuthPageFormValues): Promise<void> {
    try {
      setStatus(K.COMPONENT_STATUS.PENDING);

      const rememberMe = getRememberMeValue();

      // In response we get authentication cookie
      await gqlRequest({
        mutation: LOGIN_WITH_PASSWORD,
        variables: {
          email,
          password,
          rememberMe,
          timezoneOffset: new Date().getTimezoneOffset(),
        },
      });
      if (rememberMe) {
        localStorage.setItem('loginType', AUTH_PAGE_LOGIN_TYPE.EMAIL_PASSWORD);
        localStorage.setItem('userEmail', email);
      } else {
        localStorage.setItem('userEmail', '');
        localStorage.setItem('loginType', AUTH_PAGE_LOGIN_TYPE.SSO);
      }
      // Redirect authenticated user to the originalUrl
      window.location.replace(redirectUrl);
    } catch (err) {
      setStatus(K.COMPONENT_STATUS.REJECTED);
      setError(err);
    }
  }

  return (
    <>
      <Formik
        validationSchema={loginValidationSchema}
        validateOnChange={false}
        onSubmit={authenticateLoginPassword}
        initialValues={{ email: emailToDisplay || '', password: '' }}
        innerRef={formRef}
        enableReinitialize
      >
        {({ handleChange, values, touched, errors }): JSX.Element => (
          <Form className="AuthPage__Form">
            <div className="AuthPage__Form__Body">
              <Input
                type="email"
                name="email"
                placeholder="Email address"
                value={values.email}
                inputClassName="form-control-lg"
                onChange={handleChange}
                isInvalid={touched.email && !!errors.email}
                errorMessage={errors.email}
              />
              <Input
                type="password"
                name="password"
                placeholder="Password"
                onChange={handleChange}
                value={values.password}
                inputClassName="form-control-lg"
                isInvalid={touched.password && !!errors.password}
                errorMessage={errors.password}
              />
              <Button
                variant={ButtonVariant.PRIMARY}
                type="submit"
                size="lg"
                disabled={status === K.COMPONENT_STATUS.PENDING}
                style={{ justifyContent: 'center' }}
              >
                Log In
              </Button>
              <a href="#" onClick={changeAuthMethod} style={{ textAlign: 'center', marginTop: 16 }}>
                Log in using SSO
              </a>
            </div>
            <AuthPageFooter requestPasswordReset={requestPasswordReset} />
          </Form>
        )}
      </Formik>
    </>
  );
}

export default PasswordLogin;
